import {
    ATTACHMENT_LEVEL,
    ATTACHMENT_STATUS,
} from "../../constants/generalConstants";
import {
    CLEAR_ATTACHMENTS,
    CLEAR_SCAN_ATTACHMENT_RESULT,
    COPYING_ATTACHMENTS,
    DELETE_ALL_LINE_ITEM_ATTACHMENTS,
    DELETE_ATTACHMENT,
    DELETE_COPYING_ATTACHMENTS,
    DELETE_UPLOADING_ATTACHMENT,
    SCAN_ATTACHMENT_RESULT,
    SCAN_ATTACHMENT_RESULT_COPY,
    SET_AMEND_REQ_ATTACHMENTS,
    SET_ATTACHMENT_LINE_ITEM,
    SET_ATTACHMENT_RECIPIENTS,
    SET_AUTH_CHECK_DIALOG,
    SET_AVAILABLE_ATTACHMENTS_TO_COPY,
    SET_DISABLE_COPY,
    SET_LEVEL_TYPE,
    SHOW_ATTACHMENT_COPY_DIALOG,
    SHOW_COPY_CONFIRM_DIALOG,
    TOGGLE_SELECTED_ATTACHMENTS_FOR_DELETION,
    UPDATE_AVAILABLE_ATTACHMENTS_TO_COPY,
    UPDATE_SCAN_RESULTS_STATUS,
    UPLOADED_ATTACHMENT,
    UPLOADING_ATTACHMENT,
} from "../actionTypes";
import { initialState } from "../initialState";

// Define the reducer function
const attachmentReducers = (state = initialState.attachment, action) => {
    switch (action.type) {
        case UPLOADING_ATTACHMENT:
            return {
                ...state,
                scanResults: [
                    {
                        uploadingId: action.payload.uploadingId,
                        TITLE: action.payload.fileTitle,
                        FILENAME: action.payload.fileName,
                        LEVEL_TYPE: action.payload.levelType,
                        ATTACHMENT_LINE: action.payload.attachmentLine, //the line number in the requisition
                        DESCRIPTION: action.payload.description,
                        status: ATTACHMENT_STATUS.UPLOADING,
                        isNewUpload: true,
                        FILE_SIZE: action.payload.fileSize,
                        uniqueLineId: action.payload.uniqueLineId,
                    },
                    ...state.scanResults,
                ],
            };

        case DELETE_UPLOADING_ATTACHMENT:
            return {
                ...state,
                scanResults: state.scanResults.filter(
                    (attachment) =>
                        attachment.uploadingId !== action.payload.uploadingId
                ),
            };

        // Handle different action types
        case UPLOADED_ATTACHMENT:
            return {
                ...state,
                scanResults: state.scanResults.map((attachment) => {
                    return attachment.uploadingId === action.payload.uploadingId
                        ? {
                              ...attachment,
                              scanId: action.payload.scanId,
                              ATTACHMENT_ID: action.payload.scanId,
                              status: ATTACHMENT_STATUS.SCAN_PENDING,
                          }
                        : attachment;
                }),
            };

        case SET_AVAILABLE_ATTACHMENTS_TO_COPY:
            return {
                ...state,
                availableAttachmentsToCopy: action.payload,
            };

        case UPDATE_AVAILABLE_ATTACHMENTS_TO_COPY: {
            return {
                ...state,
                availableAttachmentsToCopy:
                    state.availableAttachmentsToCopy.map((a) => {
                        return action.payload.attachmentIds.includes(
                            a.ATTACHMENT_ID
                        )
                            ? {
                                  ...a,
                                  ...action.payload.properties,
                              }
                            : a;
                    }),
            };
        }

        case COPYING_ATTACHMENTS:
            return {
                ...state,
                scanResults: [
                    ...action.payload.attachments.map((attachment) => {
                        return {
                            ...attachment,
                            status: ATTACHMENT_STATUS.COPYING,
                            isNewUpload: true,
                        };
                    }),
                    ...state.scanResults,
                ],
            };

        // In case copy attachment api call fails, attachments have to be cleared from the state
        case DELETE_COPYING_ATTACHMENTS:
            return {
                ...state,
                scanResults: state.scanResults.filter(
                    (attachment) =>
                        !action.payload.attachments.some(
                            (a) =>
                                a.copyingId &&
                                a.copyingId === attachment.copyingId
                        )
                ),
            };

        case SCAN_ATTACHMENT_RESULT_COPY:
            return {
                ...state,
                scanResults: state.scanResults.map((attachment) => {
                    const attachmentToUpdate = action.payload?.find(
                        (a) => a.copyingId === attachment.copyingId
                    );
                    return attachmentToUpdate
                        ? {
                              ...attachmentToUpdate,
                              status: ATTACHMENT_STATUS.SCAN_PENDING,
                              isNewUpload: true,
                              isSelectedToDelete: false,
                              isStagedToDelete: false,
                          }
                        : attachment;
                }),
            };

        case SCAN_ATTACHMENT_RESULT:
            return {
                ...state,
                scanResults: state.scanResults
                    .filter((scan) => scan.scanId !== action.payload.scanId)
                    .concat({
                        LEVEL_TYPE: action.payload.levelType, //HEADER or LINE_ITEM
                        TITLE: action.payload.fileTitle, //File name in Windows
                        ATTACHMENT_TEXT: action.payload.fileTitle, //the title that the user entered when uploading
                        DESCRIPTION: action.payload.description, //entered by the user
                        FILENAME: action.payload.fileName, //the actual file name
                        ATT_FILENAME: action.payload.file_name, //the name in Azure blob Storage
                        ATTACHMENT_ID: action.payload.scanId, //the scan Id returned by the API
                        ATTACHMENT_LINE: action.payload.attachmentLine, //the line number in the requisition
                        CREATED_DATE: action.payload.created_date,
                        FILE_SIZE: action.payload.fileSize,
                        CATEGORY: [], // Recipients
                        status: action.payload.status, //scan status returned by the API
                        uniqueLineId: action.payload.uniqueLineId, //the unique line id in the requisition, only applicable for line attachments
                        isNewUpload: true,
                        isSelectedToDelete: false,
                        isStagedToDelete: false,
                    }),
            };

        case SET_AMEND_REQ_ATTACHMENTS:
            return {
                ...state,
                scanResults: action.payload
                    // it's easier to understand the attachments when it is sorted and shown in the order as the lines in the requisition.
                    .sort((a, b) => {
                        // LINE_NUM is coming from backend and linked with LINE_ATTRIBUTE5.
                        return a.LINE_NUM - b.LINE_NUM;
                    })
                    .map((attachment) => {
                        return {
                            ...attachment,
                            status: ATTACHMENT_STATUS.SCAN_COMPLETED,
                            isNewUpload: false,
                            isSelectedToDelete: false,
                            isStagedToDelete: false,
                        };
                    }),
            };

        case CLEAR_SCAN_ATTACHMENT_RESULT:
            return {
                ...state,
                scanResults: [],
                availableAttachmentsToCopy: [],
            };

        case DELETE_ATTACHMENT:
            return {
                ...state,
                availableAttachmentsToCopy:
                    state.availableAttachmentsToCopy.filter(
                        (attachment) =>
                            attachment.scanId !== action.payload.ATTACHMENT_ID
                    ),
                scanResults: state.scanResults
                    .map((attachment) => {
                        if (
                            attachment.ATTACHMENT_ID ===
                                action.payload.ATTACHMENT_ID ||
                            attachment.scanId === action.payload.ATTACHMENT_ID
                        ) {
                            if (attachment.isNewUpload) return null;
                            else
                                return {
                                    ...attachment,
                                    isStagedToDelete: true,
                                };
                        }
                        return attachment;
                    })
                    .filter((item) => item !== null),
            };

        case DELETE_ALL_LINE_ITEM_ATTACHMENTS:
            return {
                ...state,
                scanResults: state.scanResults
                    .map((attachment) => {
                        if (
                            attachment.uniqueLineId ===
                                action.payload.uniqueLineId &&
                            attachment.LEVEL_TYPE === ATTACHMENT_LEVEL.LINE
                        ) {
                            if (attachment.isNewUpload) return null;
                            else
                                return {
                                    ...attachment,
                                    isStagedToDelete: true,
                                };
                        }
                        return attachment;
                    })
                    .filter((item) => item !== null),
            };

        case SET_AUTH_CHECK_DIALOG:
            return {
                ...state,
                showAuthAttachmentDialog: action.payload,
            };

        case UPDATE_SCAN_RESULTS_STATUS:
            return {
                ...state,
                scanResults: state.scanResults.map((attachment) => {
                    if (attachment.FILE_ID === action.payload?.scanId) {
                        attachment.status = action.payload?.status;
                        attachment.OLD_ATTACHMENT_ID =
                            action.payload?.ATTACHMENT_ID;
                        attachment.ATTACHMENT_ID = action.payload?.scanId;
                        attachment.FILENAME = action.payload?.fileName;
                        attachment.isCopiedFile = action.payload?.isCopiedFile;
                    }
                    return attachment;
                }),
            };

        case SET_DISABLE_COPY:
            return {
                ...state,
                disableCopy: action.payload,
            };

        case SHOW_COPY_CONFIRM_DIALOG:
            return {
                ...state,
                showCopyConfirmDialog: action.payload,
            };

        case SHOW_ATTACHMENT_COPY_DIALOG:
            return {
                ...state,
                showAttachmentCopyDialog: action.payload,
            };

        case SET_ATTACHMENT_LINE_ITEM:
            return {
                ...state,
                attachmentLineItem: {
                    levelType: action.payload.levelType,
                    lineIndex: action.payload.index,
                    uniqueLineId: action.payload.uniqueLineId,
                },
            };

        case SET_LEVEL_TYPE:
            return {
                ...state,
                levelType: action.payload,
            };

        case CLEAR_ATTACHMENTS:
            return {
                ...state,
                scanResults: [],
            };

        case TOGGLE_SELECTED_ATTACHMENTS_FOR_DELETION:
            return {
                ...state,
                scanResults: state.scanResults.map((attachment) =>
                    action.payload.attachmentIds.includes(
                        attachment.ATTACHMENT_ID
                    )
                        ? {
                              ...attachment,
                              isSelectedToDelete:
                                  // original attachment(not new upload) can't be selected for deletion during the Post PO amendment
                                  !attachment.isNewUpload &&
                                  action.payload.isPostPOAmendment
                                      ? false
                                      : action.payload.isSelected,
                          }
                        : attachment
                ),
            };

        case SET_ATTACHMENT_RECIPIENTS:
            return {
                ...state,
                scanResults: state.scanResults.map((attachment) =>
                    action.payload.attachmentId === attachment.ATTACHMENT_ID
                        ? {
                              ...attachment,
                              CATEGORY: action.payload.selectedRecipients,
                          }
                        : attachment
                ),
            };

        default:
            return state;
    }
};

// Export the reducer
export default attachmentReducers;
